@if (headerComponent()) {
  <ng-container
    *ngComponentOutlet="headerComponent(); injector: childInjector()"
  />
} @else if (headerTemplate()) {
  <ng-container
    *ngTemplateOutlet="asTemplate(headerTemplate()!); context: templateCtx()"
  />
}

<ng-container
  *ngComponentOutlet="bodyComponent(); injector: childInjector()"
/>

@if (footerComponent()) {
  <ng-container
    *ngComponentOutlet="footerComponent(); injector: childInjector()"
  />
} @else if (footerTemplate()) {
  <ng-container
    *ngTemplateOutlet="asTemplate(footerTemplate()!); context: templateCtx()"
  />
}
